import { useRef, useEffect } from "react";
import "../styles/nav.style.css";

const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Philosophy", href: "#philosophy" },
  { label: "Listen", href: "#listen" },
  { label: "Contact", href: "#contact" },
];

interface NavProps {
  activeSection: string;
}

export function Nav({ activeSection }: NavProps) {
  const listRef = useRef<HTMLUListElement>(null);
  const itemRefs = useRef<Record<string, HTMLLIElement | null>>({});

  useEffect(() => {
    if (!activeSection) return;
    const list = listRef.current;
    const item = itemRefs.current[activeSection];
    if (!list || !item) return;
    const listRect = list.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();
    const target =
      list.scrollLeft + itemRect.left - listRect.left - (listRect.width - itemRect.width) / 2;
    list.scrollTo({ left: target, behavior: "smooth" });
  }, [activeSection]);

  return (
    <nav className="fixed top-0 left-0 right-0 z-100 flex items-center justify-between px-6 py-5 md:px-13 md:py-7 mix-blend-difference">
      <ul
        ref={listRef}
        className="nav-list flex items-center gap-11 list-none flex-1 min-w-0 overflow-x-auto"
      >
        {NAV_LINKS.map(({ label, href }) => {
          const sectionId = href.slice(1);
          const isActive = activeSection === sectionId;
          return (
            <li
              key={sectionId}
              ref={(el) => {
                itemRefs.current[sectionId] = el;
              }}
            >
              <a
                href={href}
                className={`nav-link pb-1 text-xs tracking-[0.2em] uppercase text-white no-underline relative transition-opacity duration-200 hover:opacity-100 ${isActive ? "opacity-100 active" : "opacity-65"}`}
              >
                {label}
              </a>
            </li>
          );
        })}
      </ul>
      <a
        href="#"
        className="hidden md:block shrink-0 ml-6 text-sm font-bold tracking-[0.25em] uppercase text-primary no-underline"
      >
        MOODE.ART
      </a>
    </nav>
  );
}
